import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {
        extensionPublicAPI: {constants}
    } = publicMethodUtils

    return {
        methods: {
            cssStyle: {
                CSS_SHORTHAND_MAPPINGS: constants('style.CSS_SHORTHAND_MAPPINGS')
            }
        }
    }
}
